import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'globe-ban',
  size: 24,
  node: [
    [
      'path',
      {
        d: 'M12 22a14.48 14.48 0 01-4.008-10C7.993 9.136 9 5.258 11 2.05A10 10 0 0012 22',
        key: '1cj5lm',
      },
    ],
    ['path', { d: 'm15.172 3.172 5.656 5.656', key: 'dc3sps' }],
    ['path', { d: 'M15.86 14a14.5 14.5 0 01-3.859 8 10 10 0 009.949-9', key: '1oe9di' }],
    ['path', { d: 'M2 12h10.5', key: '1ymp9b' }],
    ['circle', { cx: '18', cy: '6', r: '4', key: '14r987' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name GlobeBan
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMjJhMTQuNDggMTQuNDggMCAwMS00LjAwOC0xMEM3Ljk5MyA5LjEzNiA5IDUuMjU4IDExIDIuMDVBMTAgMTAgMCAwMDEyIDIyIiAvPgogIDxwYXRoIGQ9Im0xNS4xNzIgMy4xNzIgNS42NTYgNS42NTYiIC8+CiAgPHBhdGggZD0iTTE1Ljg2IDE0YTE0LjUgMTQuNSAwIDAxLTMuODU5IDggMTAgMTAgMCAwMDkuOTQ5LTkiIC8+CiAgPHBhdGggZD0iTTIgMTJoMTAuNSIgLz4KICA8Y2lyY2xlIGN4PSIxOCIgY3k9IjYiIHI9IjQiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/globe-ban
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const GlobeBan = createLucideIcon(__iconData);

export default GlobeBan;
